import { Service } from "@warda/library-ui/contexts/AppWebSocketContext";
const apiUrls = {
    searchSc: (index) => ({
        url: `/${Service.SC}/search/${index}`,
        method: "POST",
    }),
    msearchSc: () => ({
        url: `/${Service.SC}/msearch`,
        method: "POST",
    }),
    searchStagingArea: () => ({
        url: `/${Service.SC}/staging-area`,
        method: "POST",
    }),
    searchDashboard: (index) => ({
        url: `/${Service.DASHBOARD}/search/${index}`,
        method: "POST",
    }),
    searchProductMedia: () => ({
        url: `/${Service.SC}/products-medias`,
        method: "POST",
    }),
    searchLibraryConfig: () => ({
        url: `/${Service.SC}/library/system-configuration`,
        method: "POST",
    }),
};
export default apiUrls;
